import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { ChatHeader } from "../ChatHeader/ChatHeader";
import Typography from "../Typography/Typography";
import { ChatListStyle } from "./ChatListStyle";
import { CgProfile } from "react-icons/cg";
import Loading from "../Loadings/LoadingTable";
import { useRecoilState } from "recoil";
import { chatIdAtom } from "../../shared/chatId";
import { chatUserAtom } from "../../shared/chatUser";
const ChatList = ({ data, isLoading, handleGetChatBox }) => {
  const [recoil, setRecoil] = useRecoilState(chatIdAtom);
  const [chatUser, setChatUser] = useRecoilState(chatUserAtom);
  const localstorage = JSON.parse(localStorage.getItem("profile"));
  const IdLoggedIn = localstorage?.users[0]?.IdUser;
  const userGenerator = () => {
    const userGen = data?.map((item) => {
      if (!item?.responsible && IdLoggedIn === item.IdUser) {
        return { ...item, status: "admin" };
      } else if (item?.responsible && IdLoggedIn === item.IdUser) {
        return { ...item, status: "responsible" };
      } else if (IdLoggedIn !== item.IdUser) {
        return { ...item, status: "user" };
      } else if (item?.responsible && IdLoggedIn !== item.IdUser) {
      }
    });
    return userGen;
    // if (item?.IdUser !== IdLoggedIn) {
    //   return { ...item, status: "responsible" };
    // } else if (item?.IdUser === IdLoggedIn) {
    //   return { ...item, status: "user" };
    // }
  };

  const generated = userGenerator();
  const userGenerated = () => {
    const gen = generated?.map((item) => {
      if (item.status === "user") {
        const name =
          (item?.user?.FirstName ? item?.user?.FirstName : "") +
          " " +
          (item?.user?.LastName ? item?.user?.LastName : "");
        return (
          <div className="d-flex">
            <div className="img">
              {item?.user?.Image ? (
                <img
                  src={`https://www.apicrmmytool.metanext.biz/thumbnail/Profile/${item?.user?.Image}`}
                  alt=""
                  className="rounded-circle"
                />
              ) : (
                <CgProfile size="40px" />
              )}
            </div>
            <div className="">
              <div className="d-flex">
                <Typography size="14px">{name}</Typography>
                <Typography size="10px" primary="#a1a5b7" className="me-2 mt-1">
                  0{item?.user?.Phone}
                </Typography>
              </div>

              <Typography weight={"bold"}>
                {item?.lastMessage
                  ? (item?.lastMessage).substring(0, 30) +
                    (item?.lastMessage.length > 30 ? " ..." : "")
                  : ""}
              </Typography>
            </div>
          </div>
          // </Fragment>
        );
      }
      if (item.status === "admin") {
        return (
          <div className="d-flex">
            <div className="img">
              <CgProfile size="40px" />
            </div>
            <div className="">
              <div className="d-flex">
                <Typography size="14px">پشتیبان</Typography>
              </div>

              <Typography weight={""}>{item?.lastMessage}</Typography>
            </div>
          </div>
        );
      }

      if (item.status === "responsible") {
        const name =
          (item?.responsible?.FirstName
            ? item?.responsible?.FirstName
            : "نامشخص") +
          " " +
          (item?.responsible?.LastName ? item?.responsible?.LastName : "");
        return (
          <div className="d-flex">
            <div className="img">
              {item?.responsible?.Image ? (
                <img
                  src={`https://www.apicrmmytool.metanext.biz/thumbnail/Profile/${item?.responsible?.Image}`}
                  alt=""
                  className="rounded-circle"
                />
              ) : (
                <CgProfile size="40px" />
              )}
            </div>
            <div className="">
              <div className="d-flex">
                <Typography size="14px">{name}</Typography>
                <Typography size="10px" primary="#a1a5b7" className="me-2 mt-1">
                  0{item?.responsible?.Phone}
                </Typography>
              </div>

              <Typography weight={""}>{item?.lastMessage}</Typography>
            </div>
          </div>
        );
      }
    });
    return gen;
  };
  const items = data?.map((item, index) => {
    return (
      <li
        className="d-flex p-3 justify-content-between"
        key={index}
        onClick={() => {
          handleGetChatBox(recoil, item?.IdUser);
          setChatUser(userGenerated()[index]);
        }}
        onMouseUp={() => setRecoil(item?.IdStartChats)}
      >
        <div className="user-details">
          <Link to={""}>
            <div className="">{userGenerated()[index]}</div>
          </Link>
        </div>
        <div className="message-details">
          <Typography size="12px"> {item?.timeDifference}</Typography>
          {/* <Typography size="12px">9</Typography> */}
        </div>
      </li>
    );
  });
  return (
    <ChatListStyle className="mt-3">
      {/* <ChatHeader data={"لیست چت ها"} chatlist /> */}
      {!isLoading ? <ul className="users-list">{items}</ul> : <Loading />}
    </ChatListStyle>
  );
};

export default ChatList;
